import React from 'react'
import NextHead from 'next/head'

const Head = () => (
  <NextHead>
    <meta property="og:type" content="website" />
    <meta
      property="og:title"
      content={`Fairprice Membership | FairPrice Singapore`}
    />
    <meta property="og:site_name" content="FairPrice" />
    <title>FairPrice Membership | Self Help Portal</title>
  </NextHead>
)

export default Head
